/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ProvisionKeysRequest} from '@cash-web/protos/squareup/hieroglyph/service.pb'
import {ProvisionKeysResponse} from '@cash-web/protos/squareup/hieroglyph/service.pb'


export const provisionKeysCashBusinessPayments = (request: ProvisionKeysRequest, options?: CashRequestOptions) => post<ProvisionKeysRequest, ProvisionKeysResponse>("/2.0/cash/provision-keys-cash-business-payments", request, {...options, rejectOnError: true })